export const ApiEndPoints = {
    base_url: process.env.REACT_APP_APIURL,

    //sign in
    user_signIn: "api/v1.0/users/login",
    user_signIn_OTP: "api/v1.0/users/verify-otp",
    user_switch_tenant: "api/v1.0/tenants/switch-tenant",
    user_forget_password: "api/v1.0/users/forget-password",
    user_reset_password: "api/v1.0/users/reset-password",
    user_change_password: "api/v1.0/users/change-password",

    user_roles: "api/v1.0/users/roles",
    system_user_list: "api/v1.0/users/system-users",
    //user_list: "api/v1.0/users",

    //tenant
    tenant_search: "api/v1.0/tenants",
    tenant_create: "api/v1.0/tenants",
    tenant_update: "api/v1.0/tenants/{id}",
    tenant_get: "api/v1.0/tenants/{id}",
    tenant_add_users: "api/v1.0/tenants/{id}/users",
    tenant_user_list: "api/v1.0/tenants/{id}/users",
    tenant_user_assign_admin: "api/v1.0/tenants/{id}/assign-admin",

    //setups   
    service_types_search: "api/v1.0/jobs/service-types",
    service_types_create: "api/v1.0/jobs/service-types",
    service_types_update: "api/v1.0/jobs/service-types/{id}",

    service_search: "api/v1.0/jobs/services",
    service_create: "api/v1.0/jobs/services",
    service_update: "api/v1.0/jobs/services/{id}",

    vehicle_model_import: "api/v1.0/system/vehicle-models-import",
    vehicle_makes_search: "api/v1.0/vehicles/vehicle-makes",
    vehicle_model_search: "api/v1.0/vehicles/vehicle-models",

    tax_search: "api/v1.0/system/taxes",

    //subscriptions   
    subscription_features: "api/v1.0/subcriptions/features",
    subscription_plans: "api/v1.0/subcriptions/plans",
    subscription_plan: "api/v1.0/subcriptions/plans/{id}",
    subscription_plans_create: "api/v1.0/subcriptions/plans",
    subscription_plans_update: "api/v1.0/subcriptions/plans/{id}",
}